import { useEffect, useRef } from 'react'
import TagManager from 'react-gtm-module'

/**
 * Initialize Google Tag Manager on mount.
 * Auth flows are tracked before login, so GTM loads immediately (unlike product apps that wait for accessToken).
 */
export const useGTM = () => {
  const initialized = useRef(false)

  useEffect(() => {
    if (initialized.current) return

    const gtmId = process.env.REACT_APP_GTM_ID
    if (!gtmId) return

    TagManager.initialize({ gtmId })
    initialized.current = true
  }, [])
}
